import { useLazyQuery, useMutation, useQuery } from '@apollo/client'
import type { ApolloError } from '@apollo/client'
import {
  Button,
  ButtonBase,
  Hidden,
  Typography,
  useMediaQuery,
  useTheme
} from '@material-ui/core'
import FilterListIcon from '@material-ui/icons/FilterList'
import NavigateBeforeIcon from '@material-ui/icons/NavigateBefore'
import React, { useEffect, useRef, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { toast } from 'react-toastify'
import Lightbox from 'yet-another-react-lightbox'
import Thumbnails from 'yet-another-react-lightbox/plugins/thumbnails'
import 'yet-another-react-lightbox/plugins/thumbnails.css'
import 'yet-another-react-lightbox/styles.css'

import coverPhoto from '../../assets/images/noCoverForHotel.png'
import noResultsFound from '../../assets/images/noResultFound.svg'
import {
  CartDetails,
  cartDetailsForSearch,
  cartDetailsVar,
  cartMatchesSearch,
  isActiveCartCreation,
  isActiveCartResponse,
  parseCartDetails,
  totalQuantityVar
} from '../../cache/cart'
import AdotelSkeleton from '../../components/AdotelSkeleton'
import { RedirectModal } from '../../components/RedirectModal'
import {
  CREATE_CART_MUTATION,
  DELETE_CART_MUTATION,
  GET_CART_QUERY
} from '../../graphql/cartCrud'
import { SEARCH_AVAILABILITY_QUERY } from '../../graphql/searchAvailability'
import { WALLETS_QUERY } from '../../graphql/wallet'
import { CREDITORS_QUERY } from '../../graphql/walletCreditors'
import { cartItemPublicIdentity } from '../../helpers/cartIdentity'
import { getInitialReferer } from '../../helpers/elements'
import { errorNoCartFound, extractError } from '../../helpers/regex'
import { cleanCartData } from '../../helpers/userData'
import { useUnmountInvalidatedGeneration } from '../../hooks/useUnmountInvalidatedGeneration'
import { getTranslate, lang } from '../../localization'
import { LocalizedLink } from '../../routes/localizedRoutes'
import {
  CartItem,
  CartResponse,
  CreateCart,
  ItemInput,
  ItemsInCart
} from '../../types/cart'
import {
  Entities,
  RoomForSearch,
  SearchAvailabilityInput,
  SearchAvailabilityResponse
} from '../../types/searchAvailability'
import { WalletListItem } from '../../types/wallet'
import { CreditorListItem } from '../../types/walletCreditor'
import SearchWidgetMain from '../Booking/SearchWidgets/SearchWidgetMain'
import AccommodationNameAndAddress from './components/AccommodationNameAndAddress'
import FilterDrawer from './components/FilterDrawer'
import PropertyDescription from './components/PropertyDescription'
import RoomTypeDetails from './components/RoomTypeDetails'
import SearchAvailibilityFilters from './components/SearchAvailibilityFilters'
import { Gallery } from './components/gallery'
import { transformRoomsWithCart } from './helpers'
import useStyles from './styles/index.styles'

const BookingHotelSearchResult = () => {
  const classes = useStyles()
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const hasMountedForPrice = useRef(false)
  const hasMountedForOtherFilters = useRef(false)
  const scrollRef = useRef(0)
  const currentCartItemsRef = useRef<CartItem[]>([])
  const cartMatchesCurrentSearchRef = useRef(false)
  const cartRequestGenerationRef = useUnmountInvalidatedGeneration()
  const createCartGenerationRef = useUnmountInvalidatedGeneration()
  const [filterOpen, setFilterOpen] = useState(false)
  const [dataLoaded, setDataLoaded] = useState(false)
  const location = useLocation()
  const filterParams = new URLSearchParams(location.search)

  const filterFields = filterParams.get('filter')
  let newFilterFields: SearchAvailabilityInput | null = null
  try {
    if (filterFields) {
      newFilterFields = JSON.parse(decodeURIComponent(filterFields))
    }
  } catch (err) {
    console.error('Invalid filter JSON', err)
  }
  const [nonBillateralWallet, setNonBillateralWallet] = useState<{
    walletName: string
    walletID: number
    cashBalance: number | 0
    remainigCreditBalance: number | 0
  }>({
    walletName: '',
    walletID: -1,
    cashBalance: 0,
    remainigCreditBalance: 0
  })
  const defaultFilter: SearchAvailabilityInput = {
    channelId: '',
    arrival: '',
    departure: '',
    currency: 'IRR',
    guestsAges: [],
    sort: 'PRICE_ASC',
    propertyCode: '',
    providerCodes: [],
    showUnavailableRatePlans: false
  }

  const [searchAvailabilityInput, setSearchAvailabilityInput] =
    useState<SearchAvailabilityInput>(newFilterFields || defaultFilter)
  const searchAvailabilityInputRef = useRef(searchAvailabilityInput)
  searchAvailabilityInputRef.current = searchAvailabilityInput
  const [maxPriceRange, setmaxPriceRange] = useState<number>(0)

  const [priceRange, setPriceRange] = React.useState<number[]>([
    0,
    maxPriceRange
  ])
  const isUserPriceChange = useRef(false)
  const [allCreditors, setAllCreditors] = useState<
    {
      walletName: string
      walletID: number
      creditorItems: CreditorListItem[]
    }[]
  >([])
  const redirect = localStorage.getItem('Referer')
  const [searchData, setSearchData] = useState<Entities | undefined>(undefined)
  const [readMode, setreadMode] = useState(true)
  const [openGallary, setOpenGallary] = useState(false)
  const [showRedirectModal, setShowRedirectModal] = useState(false)
  const [redirectTitle, setRedirectTitle] = useState('')
  const [filteredRoomType, setFilteredRoomType] = useState<RoomForSearch[]>([])
  const [selectedRoomTypes, setselectedRoomTypes] = useState<string[]>([])
  const [selectedItemHash, setSelectedItemHash] = useState('')
  const [selectedRoomFacilities, setSelectedRoomFacilities] = useState<
    string[]
  >([])
  const [slides, setslides] = useState<
    {
      src: string
    }[]
  >([])

  const [itemsInCart, setItemsInCart] = useState<ItemsInCart>({
    cartID: '',
    items: []
  })

  //CREDITOR_LIST_QUERY
  const [getCreditors] = useLazyQuery<{
    creditors: CreditorListItem[]
  }>(CREDITORS_QUERY, {
    notifyOnNetworkStatusChange: true,
    fetchPolicy: 'network-only',
    onCompleted: (res) => {
      const ID = res.creditors[0].walletID
      setAllCreditors((prev) =>
        Array.isArray(prev)
          ? prev.map((ele) =>
              ele.walletID === ID
                ? {
                    ...ele,
                    creditorItems: res.creditors.filter(
                      (cr) => cr.active && cr.entity.entityType == 'Provider'
                    )
                  }
                : ele
            )
          : []
      )
    }
  })

  //GET_CART_QUERY
  const {} = useQuery<{
    wallets: WalletListItem[]
  }>(WALLETS_QUERY, {
    notifyOnNetworkStatusChange: true,
    fetchPolicy: 'network-only',
    variables: {
      filters: {
        entity: {
          entityType: 'Channel',
          entityID: ''
        },
        currency: searchAvailabilityInput.currency,
        sortBy: 'default'
      }
    },
    onCompleted: (resp) => {
      const bilateralWallets = resp.wallets.filter((w) => w.isBilateral)
      const nonBilateralWallet = resp.wallets.find((w) => !w.isBilateral)
      setNonBillateralWallet({
        walletName: nonBilateralWallet?.walletType || '',
        walletID: nonBilateralWallet?.walletID || 0,
        cashBalance: nonBilateralWallet?.walletBalance || 0,
        remainigCreditBalance: nonBilateralWallet?.remainingCreditBalance || 0
      })
      bilateralWallets.map((w) => {
        getCreditors({
          variables: {
            filters: { walletID: w.walletID, sortBy: 'default' }
          }
        })
        setAllCreditors((prev) => [
          ...prev,
          {
            walletName: w.walletType,
            walletID: w.walletID,
            creditorItems: []
          }
        ])
      })
    }
  })

  //CREATE_CART_MUTATION
  const [executeCreateCart] = useMutation<{ createCart: CreateCart }>(
    CREATE_CART_MUTATION,
    {
      notifyOnNetworkStatusChange: true,
      // Handle only the error belonging to the still-active request in the wrapper below.
      onError: () => undefined
    }
  )

  const createCart: typeof executeCreateCart = async (options) => {
    const requestGeneration = ++createCartGenerationRef.current
    const requestedCartDetails = cartDetailsForSearch(
      searchAvailabilityInputRef.current
    )
    const result = await executeCreateCart(options)
    if (
      !isActiveCartCreation({
        requestGeneration,
        activeGeneration: createCartGenerationRef.current,
        requestedCartDetails,
        search: searchAvailabilityInputRef.current
      })
    ) {
      return result
    }

    if (!result.data?.createCart) {
      setShowRedirectModal(true)
      setRedirectTitle('Creating cart failed. Try again')
      toast.error(getTranslate('Something went wrong'))
      return result
    }

    const cartID = result.data.createCart.cartID
    setItemsInCart({ cartID, items: [] })
    cartDetailsVar(requestedCartDetails)
    localStorage.setItem('cartDetails', JSON.stringify(requestedCartDetails))
    localStorage.setItem('cartID', cartID)
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    getCart({ variables: { cartID } })
    return result
  }

  const applyCartResponse = (res: { cartResponse: CartResponse }) => {
    const elements = res.cartResponse.cart.items || []
    currentCartItemsRef.current = elements
    cartMatchesCurrentSearchRef.current = true
    const totalQuantity = elements.reduce(
      (sum, item) => sum + (item.quantity || 0),
      0
    )
    totalQuantityVar(totalQuantity)
    localStorage.setItem('totalQuantity', totalQuantity.toString())
    const items: ItemInput[] = elements
      .filter((element) => element.quantity > 0)
      .map((item) => ({
        adults: item.occupancy.adults,
        arrival: item.arrival,
        departure: item.departure,
        extraBeds: item.occupancy.extraBeds,
        providerCode: cartItemPublicIdentity(item).code,
        ratePlanCode: item.ratePlan.code,
        roomTypeCode: item.roomType.code,
        useAllocated: item.useAllocated,
        quantity: item.quantity,
        price: item.price.afterDiscount.totalPrice
      }))

    setItemsInCart({
      cartID: localStorage.getItem('cartID') || '',
      items
    })

    setSearchData((currentSearchData) => {
      if (!currentSearchData) return currentSearchData

      const updatedRooms: RoomForSearch[] = currentSearchData.rooms.map(
        (room) => ({
          ...room,
          ratePlans: room.ratePlans.map((ratePlan) => ({
            ...ratePlan,
            count:
              elements.find((item) => item.hash === ratePlan.hash)?.quantity ||
              0
          }))
        })
      )
      return { ...currentSearchData, rooms: updatedRooms }
    })
  }

  const handleGetCartError = (err: ApolloError) => {
    if (extractError(err.cause?.extensions) === errorNoCartFound) {
      cleanCartData()
      currentCartItemsRef.current = []
      cartMatchesCurrentSearchRef.current = false
      setItemsInCart({ cartID: '', items: [] })
      localStorage.removeItem('confirmPrimitiveInput')
      localStorage.removeItem('confirmPrimitiveReservationState')
      localStorage.removeItem('hotelDetails')
      localStorage.removeItem('primitiveData')
      const currentSearch = searchAvailabilityInputRef.current
      if (currentSearch.propertyCode && currentSearch.currency) {
        createCart({
          variables: {
            input: {
              channelCode: '',
              currency: currentSearch.currency,
              propertyCode: currentSearch.propertyCode,
              reservationType: 'DirectGuest'
            }
          }
        })
      }
    } else {
      toast.error(getTranslate('Something went wrong'))
    }
  }

  //GET_CART_QUERY
  const [executeGetCart, { data: cartData, loading: loadingForGetCart }] =
    useLazyQuery<{
      cartResponse: CartResponse
    }>(GET_CART_QUERY, {
      notifyOnNetworkStatusChange: true,
      fetchPolicy: 'network-only'
    })

  const getCart: typeof executeGetCart = async (options) => {
    const requestGeneration = ++cartRequestGenerationRef.current
    const requestedCartID = String(options?.variables?.cartID || '')
    const result = await executeGetCart(options)
    const responseIsCurrent = isActiveCartResponse({
      requestGeneration,
      activeGeneration: cartRequestGenerationRef.current,
      requestedCartID,
      activeCartID: localStorage.getItem('cartID'),
      storedCartDetails: parseCartDetails(localStorage.getItem('cartDetails')),
      search: searchAvailabilityInputRef.current
    })

    if (!responseIsCurrent) return result
    if (result.error) {
      handleGetCartError(result.error)
    } else if (result.data) {
      applyCartResponse(result.data)
    }
    return result
  }

  //SEARCH_AVAILIBILITY_QUERY
  const [getSearchData, { loading: loadingForSearchAvailability }] =
    useLazyQuery<{ searchAvailability: SearchAvailabilityResponse }>(
      SEARCH_AVAILABILITY_QUERY,
      {
        notifyOnNetworkStatusChange: true,
        fetchPolicy: 'network-only',
        onCompleted: (res) => {
          setmaxPriceRange(
            res.searchAvailability.entities[0].entityBasicDetails.maxPrice
          )
          const entity = res.searchAvailability.entities[0]
          if (!entity) {
            setSearchData(undefined)
          }
          const cartItems = cartMatchesCurrentSearchRef.current
            ? currentCartItemsRef.current
            : []
          let updatedRooms = transformRoomsWithCart(entity.rooms, cartItems)
          setSearchData({
            ...entity,
            rooms: updatedRooms
          })
          setslides(
            entity.entityBasicDetails.images?.map((img) => ({ src: img })) || []
          )
        }
      }
    )

  //DELETE_CART_MUTATION
  const [deleteCart] = useMutation(DELETE_CART_MUTATION, {
    notifyOnNetworkStatusChange: true,
    onCompleted: () => {
      cleanCartData()
      currentCartItemsRef.current = []
      cartMatchesCurrentSearchRef.current = false
      localStorage.removeItem('confirmPrimitiveInput')
      localStorage.removeItem('confirmPrimitiveReservationState')
      localStorage.removeItem('hotelDetails')
      localStorage.removeItem('primitiveData')
      if (
        searchAvailabilityInput.propertyCode &&
        searchAvailabilityInput.currency
      ) {
        createCart({
          variables: {
            input: {
              channelCode: '',
              currency: searchAvailabilityInput.currency,
              propertyCode: searchAvailabilityInput.propertyCode,
              reservationType: 'DirectGuest'
            }
          }
        })
      }
    },
    onError: () => {
      cleanCartData()
      currentCartItemsRef.current = []
      cartMatchesCurrentSearchRef.current = false
      localStorage.removeItem('confirmPrimitiveInput')
      localStorage.removeItem('confirmPrimitiveReservationState')
      localStorage.removeItem('hotelDetails')
      localStorage.removeItem('primitiveData')
      if (
        searchAvailabilityInput.propertyCode &&
        searchAvailabilityInput.currency
      ) {
        createCart({
          variables: {
            input: {
              channelCode: '',
              currency: searchAvailabilityInput.currency,
              propertyCode: searchAvailabilityInput.propertyCode,
              reservationType: 'DirectGuest'
            }
          }
        })
      }
    }
  })

  useEffect(() => {
    getInitialReferer()
    if (readMode) {
      // Invalidate any cart response started for the previous search before issuing work for
      // this one. The next getCart call receives a fresh generation.
      cartRequestGenerationRef.current += 1
      createCartGenerationRef.current += 1
      scrollRef.current = window.scrollY
      setDataLoaded(false)

      getSearchData({
        variables: {
          input: {
            ...searchAvailabilityInput,
            walletType: localStorage.getItem('WalletType'),
            hotelPrice:
              maxPriceRange !== 0
                ? {
                    min: priceRange[0],
                    max: priceRange[1]
                  }
                : undefined,
            roomTypeFacilities: selectedRoomFacilities
          }
        }
      }).then(() => {
        requestAnimationFrame(() => {
          setDataLoaded(true)
        })
      })

      if (!localStorage.getItem('cartID')) {
        currentCartItemsRef.current = []
        cartMatchesCurrentSearchRef.current = false
        setItemsInCart({ cartID: '', items: [] })
        createCart({
          variables: {
            input: {
              channelCode: '',
              currency: searchAvailabilityInput.currency,
              propertyCode: searchAvailabilityInput.propertyCode,
              reservationType: 'DirectGuest'
            }
          }
        })
      } else {
        const cartDetails: Partial<CartDetails> | null = parseCartDetails(
          localStorage.getItem('cartDetails')
        )

        const canReuseCart = cartMatchesSearch(
          cartDetails,
          searchAvailabilityInput
        )
        cartMatchesCurrentSearchRef.current = canReuseCart

        if (canReuseCart && localStorage.getItem('cartID')) {
          getCart({ variables: { cartID: localStorage.getItem('cartID') } })
        } else {
          currentCartItemsRef.current = []
          const staleCartID = localStorage.getItem('cartID')
          cleanCartData()
          setItemsInCart({ cartID: '', items: [] })
          if (staleCartID) {
            deleteCart({
              variables: { cartID: staleCartID }
            })
          }
        }
      }
    }
  }, [readMode])

  useEffect(() => {
    if (!hasMountedForOtherFilters.current) {
      hasMountedForOtherFilters.current = true
      return
    }
    scrollRef.current = window.scrollY
    setDataLoaded(false)

    getSearchData({
      variables: {
        input: {
          ...searchAvailabilityInput,
          walletType: localStorage.getItem('WalletType'),
          hotelPrice:
            maxPriceRange !== 0
              ? {
                  min: priceRange[0],
                  max: priceRange[1]
                }
              : undefined,
          roomTypeFacilities: selectedRoomFacilities
        }
      }
    }).then(() => {
      requestAnimationFrame(() => {
        setDataLoaded(true)
      })
    })
  }, [selectedRoomFacilities, searchAvailabilityInput.showUnavailableRatePlans])

  useEffect(() => {
    if (!dataLoaded) return
    window.scrollTo({ top: scrollRef.current, behavior: 'auto' })
  }, [dataLoaded])

  useEffect(() => {
    if (!hasMountedForPrice.current) {
      hasMountedForPrice.current = true
      return
    }

    if (!isUserPriceChange.current) return

    scrollRef.current = window.scrollY
    setDataLoaded(false)

    const handler = setTimeout(() => {
      getSearchData({
        variables: {
          input: {
            ...searchAvailabilityInput,
            walletType: localStorage.getItem('WalletType'),
            hotelPrice:
              maxPriceRange !== 0
                ? {
                    min: priceRange[0],
                    max: priceRange[1]
                  }
                : undefined,
            roomTypeFacilities: selectedRoomFacilities
          }
        }
      }).then(() => {
        requestAnimationFrame(() => {
          window.scrollTo({ top: scrollY, behavior: 'auto' })
        })
      })
    }, 1500)

    return () => clearTimeout(handler)
  }, [priceRange[0], priceRange[1]])

  const disabled =
    showRedirectModal ||
    (itemsInCart.items
      ? itemsInCart.items.length < 1
        ? true
        : itemsInCart.items.every((ele) => ele.quantity === 0)
      : true)

  return (
    <>
      <div className={classes.stickyDiv}>
        <div className={classes.searchContainer}>
          <SearchWidgetMain
            setSearchAvailabilityInput={setSearchAvailabilityInput}
            searchAvailabilityInput={searchAvailabilityInput}
            readMode={readMode}
            setreadMode={setreadMode}
            isFromBooking={false}
          />
        </div>
      </div>
      <div className={classes.root}>
        <div className={classes.backButtonContainer}>
          <Button
            variant="text"
            startIcon={
              <NavigateBeforeIcon
                style={{
                  transform: lang === 'fa' ? 'rotate(180deg)' : 'none',
                  fontSize: 20
                }}
              />
            }
            onClick={() => {
              const initialRef = getInitialReferer()
              window.location.href = initialRef || '/'
            }}>
            <Typography variant="h4" className={classes.filterText}>
              {getTranslate('Back ')}
            </Typography>
          </Button>
        </div>
        {searchData && searchData?.rooms?.length > 0 ? (
          <>
            <Gallery
              images={
                searchData.entityBasicDetails.coverImage
                  ? [
                      searchData.entityBasicDetails.coverImage,
                      ...searchData.entityBasicDetails.images
                    ]
                  : searchData.entityBasicDetails.images.length > 0
                  ? searchData.entityBasicDetails.images
                  : [coverPhoto]
              }
              isCover={
                !!searchData.entityBasicDetails.coverImage ||
                searchData.entityBasicDetails.images.length === 0
              }
            />
            <AccommodationNameAndAddress searchData={searchData} />
            <PropertyDescription searchData={searchData} />
            <div className={classes.row}>
              <Typography className={classes.primaryTitle}>
                {getTranslate('Available Rooms')}
              </Typography>
              {isMobile && (
                <Button
                  variant="text"
                  startIcon={<FilterListIcon />}
                  onClick={() => setFilterOpen(true)}>
                  <Typography className={classes.primaryTitle}>
                    {getTranslate('Filters')}
                  </Typography>
                </Button>
              )}
            </div>
          </>
        ) : (
          <></>
        )}
        <div className={classes.availableRoomContainer}>
          <div className={classes.roomTypesContainer}>
            {searchData && searchData?.rooms?.length > 0 && filteredRoomType ? (
              <>
                {filteredRoomType.map((room, i) => (
                  <RoomTypeDetails
                    key={i}
                    room={room}
                    currency={searchAvailabilityInput.currency}
                    allCreditors={allCreditors}
                    searchAvailabilityInput={searchAvailabilityInput}
                    getCart={getCart}
                    loadingForGetCart={loadingForGetCart}
                    selectedItemHash={selectedItemHash}
                    setSelectedItemHash={setSelectedItemHash}
                    cartData={cartData}
                    searchData={searchData}
                    setSearchData={setSearchData}
                    roomTypeIndex={i}
                    nonBillateralWallet={nonBillateralWallet}
                    itemsInCart={itemsInCart}
                    setItemsInCart={setItemsInCart}
                  />
                ))}
                <div className={classes.btnContainer}>
                  {isMobile ? (
                    <Button
                      variant="outlined"
                      onClick={() => {
                        const initialRef = getInitialReferer()

                        window.location.href = initialRef || '/'
                      }}
                      className={classes.cancelButton}>
                      <Typography className={classes.cancelText}>
                        {getTranslate('Cancel')}
                      </Typography>
                    </Button>
                  ) : (
                    <div />
                  )}
                  <ButtonBase
                    component={LocalizedLink}
                    disableRipple
                    disableTouchRipple
                    disabled={disabled}
                    className={classes.bookingButton}
                    to={'/bookstepper/cart'}>
                    <Button
                      variant="contained"
                      color="primary"
                      disabled={disabled}
                      className={classes.btnContinue}>
                      <Typography className={classes.continueText}>
                        {getTranslate('Reserve')}
                      </Typography>
                    </Button>
                  </ButtonBase>
                </div>
              </>
            ) : (
              !loadingForSearchAvailability && (
                <div className={classes.noResultFound}>
                  <img src={noResultsFound} className={classes.img} />
                  <Typography variant="h5" className={classes.noResults}>
                    {getTranslate('No result Found')}
                  </Typography>
                </div>
              )
            )}
          </div>
          <Hidden smDown>
            <div className={classes.filtersContainer}>
              <SearchAvailibilityFilters
                searchData={searchData}
                priceRange={priceRange}
                setPriceRange={setPriceRange}
                searchAvailabilityInput={searchAvailabilityInput}
                setSearchAvailabilityInput={setSearchAvailabilityInput}
                selectedRoomFacilities={selectedRoomFacilities}
                selectedRoomTypes={selectedRoomTypes}
                setSelectedRoomFacilities={setSelectedRoomFacilities}
                setselectedRoomTypes={setselectedRoomTypes}
                isUserPriceChange={isUserPriceChange}
                itemsInCart={itemsInCart}
                setFilteredRoomType={setFilteredRoomType}
                maxPriceRange={maxPriceRange}
              />
            </div>
          </Hidden>
        </div>
      </div>
      <AdotelSkeleton
        open={loadingForSearchAvailability}
        circlesColor={theme.palette.primary.main}
        numberOfCircles={4}
      />
      <Lightbox
        open={openGallary}
        close={() => setOpenGallary(false)}
        slides={slides}
        thumbnails={{
          position: 'bottom',
          width: 100,
          height: 100,
          imageFit: 'cover'
        }}
        plugins={[Thumbnails]}
        carousel={{
          finite: true
        }}
        styles={{
          container: {
            backgroundColor: 'black'
          }
        }}
      />
      <RedirectModal
        isOpen={showRedirectModal}
        title={redirectTitle}
        onClose={() => {
          setShowRedirectModal(false)
        }}
        onClick={() => (window.location.href = redirect || `/`)}
      />
      <FilterDrawer
        open={filterOpen}
        onClose={() => setFilterOpen(false)}
        onOpen={() => {
          setFilterOpen(true)
        }}
        searchData={searchData}
        priceRange={priceRange}
        setPriceRange={setPriceRange}
        searchAvailabilityInput={searchAvailabilityInput}
        setSearchAvailabilityInput={setSearchAvailabilityInput}
        selectedRoomFacilities={selectedRoomFacilities}
        selectedRoomTypes={selectedRoomTypes}
        setSelectedRoomFacilities={setSelectedRoomFacilities}
        setselectedRoomTypes={setselectedRoomTypes}
        isUserPriceChange={isUserPriceChange}
        setFilteredRoomType={setFilteredRoomType}
        maxPriceRange={maxPriceRange}
      />
    </>
  )
}

export default BookingHotelSearchResult
